var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeWidth":"3"},[React.createElement("rect",{"x":"2","y":"2","width":"79.81","height":"54.05","rx":"7.07","key":0}),React.createElement("line",{"x1":"4.01","y1":"54.34","x2":"30.82","y2":"30.1","key":1}),React.createElement("line",{"x1":"79.86","y1":"54.28","x2":"53.48","y2":"30.46","key":2}),React.createElement("path",{"d":"M80.05,3.83,45.36,38.49a4.36,4.36,0,0,1-6.16,0l-35-35","key":3})]));
}

Envelope.defaultProps = {"className":"svg-envelope","viewBox":"0 0 83.81 58.05","stroke":"#000000","fill":"none"};

module.exports = Envelope;

Envelope.default = Envelope;
